// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1RCPb","range":"MonthRangeSwitch_range__3bEFJ","disabled":"MonthRangeSwitch_disabled__TXswM"};